// extracted by mini-css-extract-plugin
export default {"mobileMenu":"BurgerMenu_mobileMenu__Dyyta","head":"BurgerMenu_head__AEabV","closeButton":"BurgerMenu_closeButton__7leqq"};